import endpointsConfig from "endpoints.config";
import axiosInstance from "services/axiosInstance";
import { BreakerListDataType } from "typings/navbarBreakerList";

const baseURI = endpointsConfig.UserBaseUrl;

export const getBreakerListByUserId = async (): Promise<
  BreakerListDataType[]
> => {
  const url = `${baseURI}/api/Navbar/breakerlist`;

  try {
    const response = await axiosInstance.get(url);
    return structuredClone(response.data);
  } catch (error) {
    console.error("Error fetching breaker list:", error);
    throw error;
  }
};
